import { useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, Heart, Package } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { clearOrderData } from "@/lib/storage";

const PaymentSuccess = () => {
  useEffect(() => {
    // Nettoyer les données de commande après un paiement réussi
    clearOrderData();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-2xl mx-auto text-center">
          <Card className="p-8 shadow-warm">
            <div className="mb-6">
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h1 className="text-3xl font-serif font-semibold text-foreground mb-4">
                Paiement confirmé !
              </h1>
              <p className="text-xl text-muted-foreground">
                Votre abonnement Yumeli a été créé avec succès
              </p>
            </div>

            <div className="space-y-6 mb-8">
              <div className="p-4 bg-primary/5 rounded-lg border border-primary/20">
                <div className="flex items-center gap-3 mb-2">
                  <Package className="w-5 h-5 text-primary" />
                  <h3 className="font-semibold text-foreground">Prochaines étapes</h3>
                </div>
                <ul className="text-sm text-muted-foreground space-y-1 text-left">
                  <li>• Votre première box sera expédiée dans les 5 jours ouvrés</li>
                  <li>• Vous recevrez un email de confirmation avec le numéro de suivi</li>
                  <li>• Les prochaines boxes seront envoyées chaque mois à la même date</li>
                </ul>
              </div>

              <div className="p-4 bg-warm-brown/5 rounded-lg border border-warm-brown/20">
                <div className="flex items-center gap-3 mb-2">
                  <Heart className="w-5 h-5 text-warm-brown" />
                  <h3 className="font-semibold text-foreground">Gérer votre abonnement</h3>
                </div>
                <p className="text-sm text-muted-foreground text-left">
                  Un email avec vos identifiants de connexion vous a été envoyé. 
                  Vous pourrez modifier votre abonnement ou le résilier à tout moment depuis votre espace client.
                </p>
              </div>
            </div>

            <div className="space-y-3">
              <a href="/">
                <Button className="w-full bg-primary hover:bg-primary/90" size="lg">
                  Retour à l'accueil
                </Button>
              </a>
              <a href="/compte">
                <Button variant="outline" className="w-full" size="lg">
                  Accéder à mon compte
                </Button>
              </a>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PaymentSuccess;